"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportBettingSettingsDTO = void 0;
var class_transformer_1 = require("class-transformer");
var SportBettingSettingsDTO = /** @class */ (function () {
    function SportBettingSettingsDTO() {
    }
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "id", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "defaultStake1", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "defaultStake2", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "defaultStake3", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "liveEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "cashoutEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "oddsDisplay", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "expertMarketCategoriesEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "favoriteLeagueLimit", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "preselectedFavoriteLeagues", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "favoritesEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "openBetsEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "searchEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "showLiveNav", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "showSportNav", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "showDepositOptionInBetSlip", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "nextLeagueEventEnabled", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "showBalance", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "betSlipOptions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "showStakeSelector", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "sportRadar", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "statistics", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "sportCast", void 0);
    __decorate([
        (0, class_transformer_1.Expose)()
    ], SportBettingSettingsDTO.prototype, "betSharingEnabled", void 0);
    return SportBettingSettingsDTO;
}());
exports.SportBettingSettingsDTO = SportBettingSettingsDTO;
